(function (Drupal, $, once) {
  Drupal.behaviors.formdesigncenterStatusMessages = {
    attach: function (context) {
      const $button = $('.close-status-message', context);

      $(once('formdesigncenterStatusMessages', $button)).on('click', function() {
        let $region = $(this).closest('.status-message'),
            ariaHidden = $region.attr('aria-hidden');
        $region.addClass('status-message--hidden');

        if (ariaHidden === 'false') {
          $region.attr('aria-hidden', 'true');
        }
      });
    }
  };
}(Drupal, jQuery, once));